import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { PrivateRoutes } from "./private.routes";
import { PublicRoutes } from "./public.routes";

export const Router = () => {
  const { user, token } = useContext(AuthContext);
  return user === null || token === null ? <PublicRoutes /> : <PrivateRoutes />;
};
